import styles from './News.module.scss';
import { newsList } from './newsList';

export const News = () => {
	return (
		<div className={styles.news}>
			<p className={styles.news__title}>Новости</p>
			<ul className={styles.news__list}>
				{newsList.map((item, ind) => (
					<li className={styles.news__item} key={ind}>
						<div className={styles.news__img}>
							<img src={item.img} alt="news img" />
						</div>
						<div className={styles.news__info}>
							<a href={item.link} target="_blank" rel="noopener noreferrer nofollow">
								{item.title}
							</a>
							<p>{item.text}</p>
							<span>{item.date}</span>
						</div>
					</li>
				))}
			</ul>
		</div>
	);
};
